import { render, staticRenderFns } from "./PushOptIn.vue?vue&type=template&id=df8a116a&scoped=true&"
import script from "./PushOptIn.vue?vue&type=script&lang=js&"
export * from "./PushOptIn.vue?vue&type=script&lang=js&"
import style0 from "./PushOptIn.vue?vue&type=style&index=0&id=df8a116a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8a116a",
  null
  
)

export default component.exports